export interface ICicaafGeneralData {
    cicaaf_uuid: string // UUID do CICAAF
    entityType: ECicaafTipoEntidade
    isCpf: boolean
    taxId: string // CPF or CNPJ
    nameOrBusinessName: string
    city: string
    hasLegalCaf: boolean | null
    cnpjRegistrationStatus: ECicaafSituacaoCadastral | null
    unitLocation: ELocalizacaoUnidade | null
    isPartOfAssociation: boolean | null // Does the agribusiness belong to any association or cooperative?
    associationId: "uuid" | null // If “Yes”, show dropdown with list of associations/cooperatives (fetched from API)
    // adiciona o uuid do item
}

export enum ELocalizacaoUnidade {
    RURAL = "Zona Rural",
    URBANA = "Zona Urbana"
}

export enum ECicaafTipoEntidade {
    COOPERADIVA = "Cooperativa",
    ASSOCIACAO = "Associação",
    AGROINDUSTRIA = "Agroindústria"
}

export enum ECicaafSituacaoCadastral {
    ATIVA = "Ativa",
    SUSPENSA = "Suspensa",
    INAPTA = "Inapta",
    IRREGULAR = "Ativa Não Regular",
    BAIXADA = "Baixada",
    NULA = "Nula"
}